<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container" style="width: 50vw; max-width: 600px; padding: 25px; border-radius: 8px;">
                <div class="modal-header" style="border-bottom: 1px solid #eee; padding-bottom: 15px; margin-bottom: 20px;">
                    <h2 style="margin: 0; color: #E04F39; display: flex; align-items: center;">
                        <i class="pi pi-exclamation-triangle" style="margin-right: 10px; font-size: 1.2rem;"></i>
                        No Digital Chart Found
                    </h2>
                </div>

                <div class="modal-body" style="text-align: left; margin-bottom: 25px; font-size: 1.1em; line-height: 1.5;">
                    <p>This {{ $resident() }} is on Transitional Prescribing. Medications can be charted as normal. When their prescriber is set up and ready for ePrescribing, a Chart Review will move all their current medications across. </p>
                    
                    <p>Would you like to securely proceed to Chart Review now?</p>
                </div>

                <div class="modal-footer" style="display: flex; justify-content: flex-end; gap: 15px; margin-top: 20px; border-top: 1px solid #eee; padding-top: 20px;">
                    <button class="outline-button" style="border: 2px solid #aaa; color: #555; background: transparent; padding: 10px 15px; font-weight: bold; cursor: pointer; border-radius: 4px;" @click="$emit('close')">
                        Cancel
                    </button>
                    <!-- Opt-out path -->
                    <button class="outline-button" style="border: 2px solid #EF9600; color: #EF9600; background: transparent; padding: 10px 15px; font-weight: bold; cursor: pointer; border-radius: 4px;" @click="$emit('optOut')">
                        Acknowledge &amp; Transitional Conformance Prescribing
                    </button>
                    <!-- Recommended path -->
                    <button class="blue-button" style="background-color: #0870DC; color: white; border: none; padding: 10px 20px; font-weight: bold; cursor: pointer; border-radius: 4px;" @click="$emit('chartReview')">
                        Proceed to Chart Review
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LegacyPrescriptionInterceptModal'
}
</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
}
.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}
.modal-container {
    margin: 0px auto;
    background-color: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
}
</style>
